import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AlertMessageService {

  constructor(private snackBar: MatSnackBar,) { }

  public alertWarningMessage(message: string) {
    this.snackBar.open(message, '', {
      duration: 5000,
      verticalPosition: 'top',
      panelClass: ['warning-snackbar']
    });
  }

  public alertSuccessMessage(message: string) {
    this.snackBar.open(message, '', {
      duration: 5000,
      verticalPosition: 'top',
      panelClass: ['green-snackbar']
    });
  }

  public alertErrorMessage(message: string) {
    this.snackBar.open(message, '', {
      duration: 5000,
      verticalPosition: 'top',
      panelClass: ['red-snackbar']
    });
  }
}
